import React, { Fragment } from 'react';
import { observer } from 'mobx-react-lite';
import {
  useTranslation,
  gameConfigStore,
  getAmountWithCurrency,
  convertAmount,
} from '@pascal/pascal-core';
import { GAME_RULES_HELP_KEYS_TURBO } from '../../enums/constants';
import { COMBINATIONS_PAYOUTS } from '../../enums/cardTypes';
import img1 from '../../assets/images/rules/21.png';
import img2 from '../../assets/images/rules/22.png';
import img3 from '../../assets/images/rules/24.png';
import img4 from '../../assets/images/rules/27_1.png';
import img5 from '../../assets/images/rules/27_2.png';
import img6 from '../../assets/images/rules/28.png';
import img7 from '../../assets/images/rules/31.png';

export const HelpPopup = observer(() => {
  const t = useTranslation();
  const { limits: { minBet, maxBet, maxWin } = {} } = gameConfigStore;

  return (
    <div className='for-tp-rules-container'>
      <div className='tp-rules-text-container'>
        {GAME_RULES_HELP_KEYS_TURBO.map((item) => (
          <Fragment key={item}>
            <p className='tp-rules-text'>{t(`GAME_RULES_P${item + 1}`)}</p>
          </Fragment>
        ))}
        <p className='tp-rules-text'>{t(`GAME_RULES_P10`)}</p>
        <div className='rules-content-cards-wrp'>
          {COMBINATIONS_PAYOUTS.map(({ winType, rulesKey, img }) => (
            <div key={winType} className='rules-content-cards'>
              <span className='items-inner-cards-number'>{t(rulesKey)}</span>
              <span className='rules-cards-oval' />
              <div className='imag-block'>
                <img className='cards-bl' alt='a' src={img} />
              </div>
            </div>
          ))}
        </div>
        <p className='tp-rules-text title'>{t(`GAME_RULES_P20`)}</p>
        <p className='tp-rules-text'>{t(`GAME_RULES_P21`)}</p>
        <div className='tp-rules-img-container button'>
          <img className='tp-rules-image' alt='a' src={img1} />
        </div>
        <p className='tp-rules-text'>{t(`GAME_RULES_P22`)}</p>
        <div className='tp-rules-img-container'>
          <img className='tp-rules-image' alt='a' src={img2} />
        </div>
        <p className='tp-rules-text'>{t(`GAME_RULES_P23`)}</p>
        <p className='tp-rules-text'>{t(`GAME_RULES_P24`)}</p>
        <div className='tp-rules-img-container button_2'>
          <img className='tp-rules-image' alt='a' src={img3} />
        </div>
        <p className='tp-rules-text title'>{t(`GAME_RULES_P25`)}</p>
        <p className='tp-rules-text'>{t(`GAME_RULES_P26`)}</p>
        <p className='tp-rules-text'>{t(`GAME_RULES_P27`)}</p>
        <div className='tp-rules-img-container button_2'>
          <img className='tp-rules-image' alt='a' src={img4} />
          <img className='tp-rules-image' alt='a' src={img5} />
        </div>
        <p className='tp-rules-text'>{t(`GAME_RULES_P28`)}</p>
        <div className='tp-rules-img-container'>
          <img className='tp-rules-image' alt='a' src={img6} />
        </div>
        <p className='tp-rules-text'>{t(`GAME_RULES_P29`)}</p>
        <p className='tp-rules-text'>{t(`GAME_RULES_P30`)}</p>
        <p className='tp-rules-text'>{t(`GAME_RULES_P31`)}</p>
        <div className='tp-rules-img-container'>
          <img className='tp-rules-image' alt='a' src={img7} />
        </div>
        <p className='tp-rules-text title'>{t(`GAME_RULES_P32`)}</p>
        <p className='tp-rules-text'>{t(`GAME_RULES_P33`)}</p>
        <p className='tp-rules-text'>{t(`GAME_RULES_P34`)}</p>
        <p className='tp-rules-text'>{t(`GAME_RULES_P35`)}</p>
        <br />
        <p className='tp-rules-text'>
          {t(`MINIMUM_BET_AMOUNT`, {
            minBet: getAmountWithCurrency({ amount: convertAmount(minBet), withSpace: true }),
          })}
        </p>
        <p className='tp-rules-text'>
          {t(`MAXIMUM_BET_AMOUNT`, {
            maxBet: getAmountWithCurrency({ amount: convertAmount(maxBet), withSpace: true }),
          })}
        </p>
        <p className='tp-rules-text'>
          {t(`MAXIMUM_WINNING_LIMIT`, {
            maxWin: getAmountWithCurrency({ amount: convertAmount(maxWin), withSpace: true }),
          })}
        </p>
        <br />
        <p className='tp-rules-text title'>{t(`GAME_RULES_P36`)}</p>
        {COMBINATIONS_PAYOUTS.map(({ winType, rulesKey, odd }) => (
          <div key={winType} className='rules-content-cards'>
            <span className='items-inner-cards-number'>{t(rulesKey)}</span>
            <span className='rules-cards-oval' />
            <p className='rules-cards-bet-amount'>x{odd}</p>
          </div>
        ))}
        <p className='tp-rules-text title'>RTP: 98.34%</p>
      </div>
    </div>
  );
});
